import { optionalUuidArray } from '../zod-helpers/index.js';
import { PROMOTION_CONSTRAINTS } from './constraints.js';
const { maxItems } = PROMOTION_CONSTRAINTS.categoryIds;
// WHY: the column holds a JSON array of lowercase ids, so ids are lowercased before the dedupe drops a repeated pick.
export const promotionCategoryIdsSchema = optionalUuidArray('Invalid category selection.', {
    maxItems,
    tooManyMessage: `Select at most ${String(maxItems)} categories.`,
})
    .transform((ids) => [...new Set(ids.map((id) => id.toLowerCase()))])
    .nullable()
    .optional();
//# sourceMappingURL=promotion-category-ids-schema.js.map